"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Pagination = _interopRequireDefault(require("react-bootstrap/Pagination"));
var _customHooks = require("./custom-hooks");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const Pagination = _ref => {
  let {
    currentPage,
    numberOfItems,
    itemsPerPage,
    onChange,
    prefix
  } = _ref;
  const numberOfPages = Math.ceil(numberOfItems / itemsPerPage);
  const bestPage = Math.max(Math.min(numberOfPages, currentPage), 1);
  const size = (0, _customHooks.useWindowSize)();
  const prevProps = {
    className: 'stepper'
  };
  const nextProps = {
    className: 'stepper'
  };
  const handleChange = newPageNumber => event => {
    onChange(newPageNumber, event);
  };
  const renderPaginationItem = (number, index) => {
    const itemProps = {
      key: number === '...' ? number + index : number,
      active: number === bestPage,
      disabled: number === '...'
    };

    // prefix allows user to specify a url ex: [prefix](?page=)[number](desired page number)
    if (prefix) {
      itemProps.href = prefix + number;
    } else {
      itemProps.onClick = handleChange(number);
    }
    return /*#__PURE__*/_react.default.createElement(_Pagination.default.Item, itemProps, number);
  };
  const getBuffer = (current, last) => {
    if (size.width > 768) {
      return 2;
    } else {
      if (last - current <= 2 || current <= 2) {
        return 2;
      }
      return 1;
    }
  };
  const paginationGenerator = (current, last) => {
    const buffer = getBuffer(current, last);
    const left = current - buffer;
    const right = current + buffer;
    const range = [];
    const rangeWithDots = [];
    let l;
    for (let i = 1; i <= last; i += 1) {
      /* istanbul ignore next */
      if (i === 1 || i === last || i >= left && i <= right) {
        range.push(i);
      } else if (i < left) {
        i = left - 1;
      } else if (i > right) {
        range.push(last);
        break;
      }
    }
    range.forEach(i => {
      if (l) {
        if (i - l === 2) {
          rangeWithDots.push(l + 1);
        } else if (i - l !== 1) {
          rangeWithDots.push('...');
        }
      }
      rangeWithDots.push(i);
      l = i;
    });
    return rangeWithDots.map((item, index) => renderPaginationItem(item, index));
  };
  const renderPageNumbers = () => {
    const pageNumbers = [];
    for (let i = 1; i <= numberOfPages; i++) {
      pageNumbers.push(renderPaginationItem(i));
    }
    return pageNumbers;
  };
  if (numberOfPages <= 6) {
    return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
      className: "pagination"
    }, renderPageNumbers());
  } else {
    if (prefix) {
      prevProps.href = `${prefix}${bestPage - 1}`;
      nextProps.href = `${prefix}${bestPage + 1}`;
    } else {
      prevProps.onClick = handleChange(bestPage - 1);
      nextProps.onClick = handleChange(bestPage + 1);
    }
    return /*#__PURE__*/_react.default.createElement(_Pagination.default, {
      className: "pagination"
    }, /*#__PURE__*/_react.default.createElement(_Pagination.default.Prev, _extends({
      disabled: bestPage === 1
    }, prevProps), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    })), paginationGenerator(bestPage, numberOfPages), /*#__PURE__*/_react.default.createElement(_Pagination.default.Next, _extends({
      disabled: bestPage === numberOfPages
    }, nextProps), /*#__PURE__*/_react.default.createElement("span", {
      className: "sr-only"
    })));
  }
};
var _default = exports.default = Pagination;
Pagination.propTypes = {
  /**
   * The current page.
   */
  currentPage: _propTypes.default.number.isRequired,
  /**
   * The number of items per page.
   */
  itemsPerPage: _propTypes.default.number.isRequired,
  /**
   * The total number of individual items represented by this paginator.
   */
  numberOfItems: _propTypes.default.number.isRequired,
  /**
   * The handler function invoked when a new page is selected.
   */
  onChange: _propTypes.default.func,
  /**
   * The optional url prefix if each page item navigates to a new page.
   */
  prefix: _propTypes.default.string
};
Pagination.defaultProps = {
  currentPage: 1
};